import { render } from "./ThreeRandselThread.vue?vue&type=template&id=11c69aec&ts=true"
import script from "./ThreeRandselThread.vue?vue&type=script&lang=ts"
export * from "./ThreeRandselThread.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__